import {
  CompoundPlateInfoState,
  IntermediatePlateInfoState,
  NucleofectionPlateInfoState,
  SourcePlateInfoState,
} from "./state";

export const getSourcePlateInfoState = (): SourcePlateInfoState => {
  return {
    plateBarcode: "",
    labwareTypeCode: "",
    operatingVol: 0,
    rows: [],
    cols: [],
    wellInfo: [],
  };
};

export const getCompoundPlateInfoState = (): CompoundPlateInfoState => {
  return {
    index: 0,
    plateBarcode: "",
    labwareTypeCode: "",
    operatingVol: 0,
    rows: [],
    cols: [],
    wellInfo: [],
    transferVol: "25",
  };
};

export const getNucleofectionPlateInfoState =
  (): NucleofectionPlateInfoState => {
    return {
      index: 0,
      plateBarcode: "",
      labwareTypeCode: "",
      operatingVol: 0,
      minOperatingVol: 0,
      numberOfWashes: 0,
      topUpVol: 160,
      rows: [],
      cols: [],
      wellInfo: [],
      washVol: 0,
    };
  };

export const getIntermediatePlateInfoState = (): IntermediatePlateInfoState => {
  return {
    plateBarcode: "",
    labwareTypeCode: "",
    operatingVol: 0,
    rows: [],
    cols: [],
  };
};
